import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterCategories from 'views/products/categories/filterCategories'; // Importing FilterCategories component
import TableCategories from 'views/products/categories/tableCategories'; // Importing TableCategories component
import DetailsCategories from 'views/products/categories/detailsCategories'; // Importing DetailsCategories component
import RecordCategories from 'views/products/categories/recordCategories'; // Importing RecordCategories component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * CategoriesView class extending JetView to create a view for categories.
 */
export default class CategoriesView extends JetView {
    /**
     * Configures the layout of the CategoriesView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default page size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the dropdown
                    id: 'Export', // Unique identifier for the dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index on the current page
                            var last = first + size - 1; // Last item index on the current page
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + 'Categorías', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter function for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        ); // Filter items based on index
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Categorías', // Filename for the export
                                    ignore: { rating: true }, // Ignore rating field during export
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Categorías', // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter function for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            ); // Filter items based on index
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Categorías', // Filename for the export
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: { rating: true }, // Ignore rating field during export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown value
                        }.bind(this), // Bind 'this' context
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Left side layout
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply current theme
                    elements: [
                        // Elements in the toolbar
                        { view: 'label', label: _('Categorías') }, // Label for categories
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate
                                },
                            ],
                        },
                    ],
                },
                FilterCategories, // Filter categories component
                TableCategories, // Table categories component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the view
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive design for the view
                    type: 'wide', // Wide type for layout
                    cols: [left], // Left column layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view (export dropdown)
                $$('pagerA').define('group', 1); // Define pager grouping
            }
        });
    }
}

// FILE DOCUMENTED
